import apiRequestCommon from './index'

export default {
  path: '/v1/getAppVer',
  async get () {
    return apiRequestCommon.get(`${this.path}`)
  }
}
